import Link from 'found/Link';
import PropTypes from 'prop-types';
import React from 'react';

import BadgeActiveTimeRange from 'src/components/Badge/BadgeActiveTimeRange';
import Loading from 'src/components/Loading';
import UUID from 'src/components/UUID';
import getFullAddressString from 'src/util/address';

/**
 * Description
 * @param {object} props
 * @returns {React.ReactComponentElement} - AdminCommunityShowProperty component
 */
function AdminCommunityShowProperty(props) {
  if (!props) {
    return <tr><td aria-label="loading" colSpan={4}><Loading /></td></tr>;
  }

  const { property } = props;
  const {
    id, title, externalIdentifier, active, address,
  } = property;

  const addr = getFullAddressString(address);

  return (
    <tr key={`property-${id}`}>
      <th scope="row">
        <Link to={`/admin/properties/${id}`}>
          {title}
        </Link>
        {addr && (
        <>
          <br />
          {addr}
        </>
        )}
      </th>
      <td>
        <UUID uuid={id} />
      </td>
      <td>
        {externalIdentifier}
      </td>
      <td>
        <BadgeActiveTimeRange active={active} />
      </td>
    </tr>
  );
}

AdminCommunityShowProperty.propTypes = {
  property: PropTypes.shape({
    id: PropTypes.string,
    externalIdentifier: PropTypes.string,
    title: PropTypes.string,
    active: PropTypes.shape({
      start: PropTypes.number,
      finish: PropTypes.number,
    }),
    address: PropTypes.shape({
      line1: PropTypes.string,
      line2: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      postcode: PropTypes.string,
    }),
  }),
};

AdminCommunityShowProperty.defaultProps = {
  property: null,
};

export default AdminCommunityShowProperty;
